import React, { useRef, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import {
  NewsletterContainer
} from './NewsletterHTML.styles';

import {
  useResize
} from '../../hooks';

const NewsletterHTML = ({
  html,
}) => {
  const container = useRef(null);
  const [scale, setScale] = useState(1);
  const [marginBottom, setMarginBottom] = useState(0);
  const { width, height } = useResize(container);

  useLayoutEffect(() => {
    if (width < 450 && width !== 0) {
      const newScale = width / 450;
      setScale(newScale);

      const newMarginBottom = -(height * (1 - newScale));
      setMarginBottom(newMarginBottom);
    } else {
      setScale(1);
      setMarginBottom(0);
    }
  }, [width, html]);
  
  return (
    <NewsletterContainer ref={container} scale={scale} marginBottom={marginBottom}>
      {/* eslint-disable-next-line */}
      <div dangerouslySetInnerHTML={{__html: html}} />
    </NewsletterContainer>
  );
}

NewsletterHTML.propTypes = {
  html: PropTypes.string,
};

export default NewsletterHTML;